module.exports = __webpack_public_path__ + "static/img/comer.725c49b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/comer.jpg
// module id = Zs6M
// module chunks = 1